import { useMemo } from 'react'
import { useAppSelector } from '../../../../stateManagement/hooks/redux'

export function useRepairPlanFilters(newestRepairPlan: any) {
    const { appliedFilters, tableUnderMapFiltersExpressions } = useAppSelector(state => state.maps.repairPlan)
    
    const mergedMapFilters = useMemo(() => {
        const base = appliedFilters ?? {};
        const repairPlanId = newestRepairPlan?.RepairPlanID
        return newestRepairPlan != null ? { ...base, RepairPlanId: repairPlanId } : base;
    }, [appliedFilters, newestRepairPlan])

    const thresholdsFilter = useMemo(() => {
        const repairPlanId = newestRepairPlan?.RepairPlanID
        if (repairPlanId == null) return undefined
        
        const baseFilters: string[] = []
        const dyn = Object.values(tableUnderMapFiltersExpressions ?? {}).filter(Boolean) as string[]
        if (dyn.length) baseFilters.push(dyn.join(' and '))
        baseFilters.push(`RepairPlanId eq ${repairPlanId}`)
        return baseFilters.join(' and ')
    }, [tableUnderMapFiltersExpressions, newestRepairPlan])

    return { mergedMapFilters, thresholdsFilter }
}

